export default "/images/morsix-dark.svg?98366c958d8bbc047c95a77ff603ae69";